/*
 * The Illuminatee — flashing cart-count favicon.
 * Draws the number of items in the cart as a red badge on the favicon and
 * blinks it on/off while the browser tab is inactive (to lure shoppers back).
 * Self-contained, no dependencies. Disable it in the Illuminatee Global Code
 * section before removing this file or its loader entry.
 */
(function () {
  'use strict';
  if (typeof document === 'undefined' || !document.head || !window.fetch) return;
  if (window.__illmnFaviconFlashInitialized) return;
  window.__illmnFaviconFlashInitialized = true;

  var FLASH_MS = 800;          // blink speed (ms)
  var BADGE_BG = '#933b37';    // brand red badge
  var BADGE_FG = '#ffffff';    // number colour

  var originalHref = getIconHref();
  var baseImg = null, baseLoaded = false;
  var plainUrl = originalHref, badgedUrl = null;
  var count = 0, timer = null, showBadge = false;
  var refreshTimer = null, cartRevision = 0;
  var managedIconLink = null, iconRevision = 0;

  function getIconHref() {
    var l = document.querySelector('link[rel~="icon"]');
    return l ? l.href : (location.origin + '/favicon.ico');
  }

  function versionedIconHref(href) {
    iconRevision += 1;
    return href + (href.indexOf('#') === -1 ? '#' : '&') + 'illmn-frame=' + iconRevision;
  }

  // Keep one favicon node alive and give every frame a unique URL. Reusing the
  // same two URLs can make Chromium stop repainting the favicon after a few
  // alternations even though the interval itself is still running.
  function setIcon(href) {
    if (!href) return;

    if (!managedIconLink || !managedIconLink.parentNode) {
      var links = document.querySelectorAll('link[rel~="icon"]');
      for (var i = 0; i < links.length; i++) {
        if (links[i].parentNode) links[i].parentNode.removeChild(links[i]);
      }

      managedIconLink = document.createElement('link');
      managedIconLink.rel = 'icon';
      managedIconLink.type = 'image/png';
      document.head.appendChild(managedIconLink);
    }

    managedIconLink.href = versionedIconHref(href);
  }

  function roundRect(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }

  function drawBadge(ctx, size, n) {
    var label = n > 99 ? '99+' : String(n);
    var r = size * 0.34;
    var cx = size - r - size * 0.02;
    var cy = r + size * 0.02;
    ctx.beginPath();
    ctx.arc(cx, cy, r, 0, Math.PI * 2);
    ctx.fillStyle = BADGE_BG;
    ctx.fill();
    ctx.lineWidth = size * 0.05;
    ctx.strokeStyle = '#ffffff';
    ctx.stroke();
    ctx.fillStyle = BADGE_FG;
    var fs = label.length > 2 ? r * 0.9 : r * 1.25;
    ctx.font = '700 ' + Math.round(fs) + 'px Arial, sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(label, cx, cy + size * 0.02);
  }

  function buildIcons() {
    var size = 64;
    var canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;
    var ctx = canvas.getContext('2d');
    if (!ctx) return;

    function base() {
      ctx.clearRect(0, 0, size, size);
      if (baseLoaded && baseImg) {
        try { ctx.drawImage(baseImg, 0, 0, size, size); return; } catch (e) {}
      }
      ctx.fillStyle = '#0b0b0a';
      roundRect(ctx, 0, 0, size, size, 12);
      ctx.fill();
    }

    base();
    try { plainUrl = canvas.toDataURL('image/png'); } catch (e) { plainUrl = originalHref; }

    base();
    drawBadge(ctx, size, count);
    try { badgedUrl = canvas.toDataURL('image/png'); } catch (e) { badgedUrl = null; }
  }

  function startFlash() {
    if (timer || !badgedUrl) return;
    showBadge = false;
    timer = setInterval(function () {
      showBadge = !showBadge;
      setIcon(showBadge ? badgedUrl : (plainUrl || originalHref));
    }, FLASH_MS);
  }

  function stopFlash() {
    if (timer) { clearInterval(timer); timer = null; }
    setIcon(plainUrl || originalHref);
  }

  function evaluate() {
    if (document.hidden && count > 0 && badgedUrl) startFlash();
    else stopFlash();
  }

  function setCount(value) {
    var next = Number(value);
    if (!isFinite(next) || next < 0) next = 0;
    next = Math.floor(next);
    if (next !== count) {
      count = next;
      buildIcons();
    }
  }

  function refreshCount(then) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart && typeof cart.item_count === 'number' ? cart.item_count : 0);
        if (then) then();
      })
      .catch(function () {});
  }

  function scheduleRefresh(delay) {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      refreshTimer = null;
      refreshCount(evaluate);
    }, typeof delay === 'number' ? delay : 0);
  }

  function loadBase(done) {
    if (!originalHref) { done(); return; }
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () { baseImg = img; baseLoaded = true; done(); };
    img.onerror = function () { baseLoaded = false; done(); };
    img.src = originalHref;
  }

  loadBase(function () {
    buildIcons();
    refreshCount(evaluate);
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) refreshCount(evaluate);
    else stopFlash();
  });

  // Horizon 6 announces authoritative cart totals through Shopify's standard event.
  // A revision token prevents a slower, older response from overwriting a newer one.
  document.addEventListener('shopify:cart:lines-update', function (event) {
    var revision = ++cartRevision;
    var promise = event && event.promise;

    if (!promise || typeof promise.then !== 'function') {
      scheduleRefresh(0);
      return;
    }

    promise.then(
      function (result) {
        if (revision !== cartRevision) return;
        if (refreshTimer) {
          clearTimeout(refreshTimer);
          refreshTimer = null;
        }

        var cart = result && result.cart;
        if (cart && typeof cart.totalQuantity === 'number' && isFinite(cart.totalQuantity)) {
          setCount(cart.totalQuantity);
          evaluate();
        } else {
          scheduleRefresh(0);
        }
      },
      function () {
        if (revision === cartRevision) scheduleRefresh(0);
      }
    );
  });

  // Keep the legacy network hook for apps and older cart flows.
  var _fetch = window.fetch;
  window.fetch = function () {
    var p = _fetch.apply(this, arguments);
    try {
      var a0 = arguments[0];
      var url = typeof a0 === 'string' ? a0 : (a0 && a0.url) || '';
      if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        p.then(
          function () { scheduleRefresh(300); },
          function () {}
        );
      }
    } catch (e) {}
    return p;
  };

  document.addEventListener('cart:update', function () {
    cartRevision++;
    scheduleRefresh(0);
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) scheduleRefresh(0);
  });

  window.addEventListener('pagehide', function () {
    cartRevision++;
    if (refreshTimer) {
      clearTimeout(refreshTimer);
      refreshTimer = null;
    }
    stopFlash();
  });

  document.addEventListener('DOMContentLoaded', function () { refreshCount(evaluate); });
})();
